/* eslint-disable jsx-a11y/heading-has-content */
import { ELEMENT_PARAGRAPH } from '@doltech/utils/lib/constants';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import {
  defaultIsEmptyText,
  EditorPlaceHolder,
} from '../../../shared/components/IELTSample/Outline/Paragraph/components/EditorPlaceHolder';
import { ELEMENT_H1 } from '../../../slatePlugins';
import { SlatePlugin } from '../../../slatePlugins/slatePlugins.types';

const Main = styled.div`
  .placeholder-paragraph {
    font-size: 16px;
    line-height: 20px;
  }
  .placeholder-h1 {
    font-size: 29px;
    line-height: 36px;
  }
  h1 {
    margin-bottom: 12px;
  }
`;

export const PlaceholderPlugin = ({ isReadOnly = false }): SlatePlugin => {
  return {
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;
      if (isReadOnly) return null;
      if (!element.placeholder) return null;
      const { placeholder } = element;
      switch (element.type) {
        case ELEMENT_PARAGRAPH: {
          return (
            <Main>
              <EditorPlaceHolder
                isEmptyText={() => {
                  return defaultIsEmptyText(element);
                }}
                placeholderClassName="placeholder-paragraph"
                placeHolderText={placeholder}
              >
                <p {...renderProps} />
              </EditorPlaceHolder>
            </Main>
          );
        }
        case ELEMENT_H1: {
          return (
            <Main>
              <EditorPlaceHolder
                isEmptyText={() => {
                  return defaultIsEmptyText(element);
                }}
                placeholderClassName="placeholder-h1"
                placeHolderText={placeholder}
              >
                <h1 {...renderProps} />
              </EditorPlaceHolder>
            </Main>
          );
        }
        default:
      }
      return null;
    },
  };
};
